export interface ChatMessage {
  id: string;
  content: string;
  sender: ChatParticipant;
  timestamp: Date;
}

export interface ChatParticipant {
  id: string;
  name: string;
  role: string;
  isOnline: boolean;
}

// Интерфейсы для интервью
export interface InterviewMessage {
  id: string;
  content: string;
  isFromAI: boolean;
  timestamp: Date;
}

export interface InterviewState {
  isActive: boolean;
  isCompleted: boolean;
  messages: InterviewMessage[];
  currentStep: number;
  userProfile?: UserProfile;
}

export interface UserProfile {
  niche?: string;
  goals?: string[];
  targetAudience?: string;
  contentStyle?: string;
  challenges?: string[];
}

// Интерфейсы для чата с контекстом поста
export interface PostChatMessage {
  id: string;
  content: string;
  messageType?: 'text' | 'audio' | string;
  audioUrl?: string | null;
  imageUrls?: string[] | null;
  durationMs?: number | null;
  isFromAI: boolean;
  timestamp: string;
  isFromCurrentUser?: boolean;
}

// Интерфейс для ссылки поста
export interface PostLink {
  name: string;
  url: string;
}

export interface PostContext {
  platform: string;
  format: string;
  title: string;
  idea: string;
  content: string;
  carouselHtmlJson?: string;
  carouselTemplateId?: string;
  date?: string;
  coverImage?: string;
  coverCardHtml?: string;
  links?: PostLink[];
}

export interface OriginalValues {
  title?: string;
  idea?: string;
  content?: string;
  carouselHtmlJson?: string;
  coverCardHtml?: string;
}

export type ChatPostUpdateData = {
  title?: string;
  idea?: string;
  content?: string;
  coverImage?: string;
  coverCardHtml?: string;
  carouselHtmlJson?: string;
};

export interface PostChatRequest {
  contentPlanId: string;
  postId?: string;
  message: string;
  postContext: PostContext;
}

export interface PostChatAudioRequest {
  contentPlanId: string;
  postId?: string;
  audioKey: string;
  audioUrl: string;
  audioMimeType: string;
  durationMs: number;
  postContext: PostContext;
}

export interface PostChatResponse {
  messageId: string;
  content: string;
  isFromAI: boolean;
  timestamp: string;
}

// Статусы чата поста
export enum PostChatStatus {
  Idle = 0,
  AITyping = 1,
  Processing = 2,
  GeneratingImage = 3
}

// Событие изменения статуса чата
export interface PostChatStatusEvent {
  contentPlanId: string;
  postId?: string;
  status: PostChatStatus;
  data?: any;
}
